import { render, staticRenderFns } from "./sandbox_images.vue?vue&type=template&id=13fc807d&scoped=true&"
import script from "./sandbox_images.vue?vue&type=script&lang=ts&"
export * from "./sandbox_images.vue?vue&type=script&lang=ts&"
import style0 from "./sandbox_images.vue?vue&type=style&index=0&id=13fc807d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fc807d",
  null
  
)

export default component.exports